import { api, apiPublic } from "api/api";
import { AxiosError } from "axios";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import { ChartMultiBarModel } from "model/chart/ChartMultiBarModel";
import { ChartPieModel } from "model/chart/ChartPieModel";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";

export type AuditoriaDashboardFilters = {
    unidadeOrganizacional?: number | null;
    setor?: number | null;
    planos: number[] | null;
    dataGeracao: { inicio: string | Date, fim: string | Date }
}

class AuditoriaDashboardService {

    getGraficoNaoConformidadePizza(filters?: AuditoriaDashboardFilters) {
        if (!filters) filters = { planos: null, dataGeracao: { inicio: '', fim: '' } };

        const url = `/auditoria/dashboard/naoConformidade/pizza?filters=${encodeURIComponent(JSON.stringify(filters))}`;
        return new Promise<ChartPieModel>((resolve, reject): void => {
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getAuditoriasNaoConformidade(page: Pageable, filters?: AuditoriaDashboardFilters) {
        if (!filters) filters = { planos: null, dataGeracao: { inicio: '', fim: '' } };
        const params = {
            page: page.page,
            size: page.size,
            sort: page.sort,
        };
        const url = `/auditoria/dashboard/naoConformidade/tabela?filters=${encodeURIComponent(JSON.stringify(filters))}`;
        return new Promise<Page>((resolve, reject): void => {
            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getGraficoNaoConformidadeBarras(filters?: AuditoriaDashboardFilters) {

        const url = `/auditoria/dashboard/naoConformidade/barras?filters=${encodeURIComponent(JSON.stringify(filters))}`;
        return new Promise<ChartMultiBarModel>((resolve, reject): void => {
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getRelatorioListagemNaoConformidade(filters?: AuditoriaDashboardFilters) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/auditoria/report/listagem/naoConformidade?filters=${encodeURIComponent(JSON.stringify(filters))}`;
            
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default AuditoriaDashboardService;
